<template>
    <div class="map-overview flex-center" v-if="value">
        <div class="map-container">
            <div class="map-chart">
                <MapBox
                    :location="location"
                    v-if="location"
                    :scrollWhell="true"
                    :draggable="true"
                    :iconSize="36"
                    :zoom="17"
                    :operate="true"
                ></MapBox>
            </div>

            <div class="close-icon flex-center" @click="$emit('input', false)">
                <i class="el-icon-close"></i>
            </div>
        </div>
    </div>
</template>

<script>
import MapBox from "./MapBox.vue";

export default {
    data() {
        return {};
    },

    model: {
        prop: "value",
        event: "input",
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },

        location: {
            type: String,
            required: true,
        },
    },

    components: {
        MapBox,
    },
};
</script>

<style lang="scss" scoped>
.map-overview {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;

    .map-container {
        width: 90%;
        aspect-ratio: 16 / 9;
        // background-color: #f5f5f5;
        border-radius: 16px;
        position: relative;
        overflow: hidden;

        .map-chart {
            position: absolute;
            inset: 0;
        }

        .close-icon {
            width: 32px;
            height: 32px;
            position: absolute;
            right: 12px;
            top: 12px;
            border-radius: 4px;
            background-color: rgba(0, 0, 0, 0.3);
            cursor: pointer;

            i {
                color: #ffffffea;
                font-size: 20px;
            }

            &:hover {
                background-color: rgba(0, 0, 0, 0.4);
            }
        }
    }
}
</style>
